import { useState } from "react";
import { Button, IconButton } from "@radix-ui/themes";
import {
  ChartDonut,
  CirclesThreePlus,
  CloudCheck,
  CurrencyDollar,
  Database,
  Desktop,
  Gauge,
  House,
  List,
  SignOut,
  UserCircle,
  UsersThree,
  X,
} from "@phosphor-icons/react";

import type { Icon } from "@phosphor-icons/react";
import type { AdminRoute } from "../../types";
import type { AdminShellProps } from "./index.types";

const groups: Array<{ label: string; items: Array<{ route: AdminRoute; title: string; description: string; icon: Icon }> }> = [
  { label: "GENEL", items: [{ route: "overview", title: "Genel durum", description: "Platform özeti", icon: House }] },
  {
    label: "HESAPLAR VE ALANLAR",
    items: [
      { route: "accounts", title: "Hesaplar", description: "UID veya e-posta ile ara", icon: UsersThree },
      { route: "workspaces", title: "Workspace'ler", description: "Alan, üye ve kaynaklar", icon: Database },
      { route: "devices", title: "Cihaz kayıtları", description: "Çevrimdışı erişim cihazları", icon: Desktop },
    ],
  },
  {
    label: "KULLANIM VE OPERASYON",
    items: [
      { route: "costLimits", title: "Maliyet limitleri", description: "Canlı AI bütçe tavanları", icon: CurrencyDollar },
      { route: "usage", title: "Kullanım politikası", description: "AI bütçesi ve kapasite", icon: Gauge },
      { route: "operations", title: "Sistem sağlığı", description: "API, sayaçlar ve yayınlar", icon: CloudCheck },
    ],
  },
];

export function AdminShell({ activeRoute, children, mode, onNavigate, onSignOut, user }: AdminShellProps) {
  const [open, setOpen] = useState(false);
  const navigate = (route: AdminRoute) => {
    setOpen(false);
    onNavigate(route);
  };
  return (
    <div className="admin-app">
      <aside className={`sidebar${open ? " open" : ""}`}>
        <div className="brand-row">
          <Button className="brand" onClick={() => navigate("overview")} type="button" aria-label="Genel duruma dön" variant="ghost">
            <span className="brand-mark"><CirclesThreePlus weight="fill" size={20} /></span>
            <span><strong>TAYAN</strong><small>YÖNETİM</small></span>
          </Button>
          <IconButton className="sidebar-close" onClick={() => setOpen(false)} type="button" aria-label="Menüyü kapat" variant="ghost"><X size={20} /></IconButton>
        </div>
        <nav aria-label="Yönetim sayfaları">
          {groups.map((group) => (
            <section className="nav-group" key={group.label}>
              <span>{group.label}</span>
              {group.items.map((item) => {
                const NavIcon = item.icon;
                return (
                  <Button
                    aria-current={activeRoute === item.route ? "page" : undefined}
                    className={activeRoute === item.route ? "active" : ""}
                    key={item.route}
                    onClick={() => navigate(item.route)}
                    type="button"
                    variant="ghost"
                  >
                    <NavIcon size={19} />
                    <span><strong>{item.title}</strong><small>{item.description}</small></span>
                  </Button>
                );
              })}
            </section>
          ))}
        </nav>
        <div className="sidebar-user">
          <UserCircle size={30} />
          <span><strong>{user.email ?? user.id}</strong><small>Platform yöneticisi</small></span>
          <IconButton onClick={onSignOut} type="button" aria-label="Çıkış yap" variant="ghost"><SignOut size={18} /></IconButton>
        </div>
      </aside>
      <section className="app-stage">
        <header className="mobile-header">
          <IconButton onClick={() => setOpen(true)} type="button" aria-label="Menüyü aç" variant="ghost"><List size={22} /></IconButton>
          <strong>TAYAN <span>YÖNETİM</span></strong>
        </header>
        {mode === "demo" ? (
          <div className="demo-banner" role="status">
            <ChartDonut size={17} />
            <strong>Örnek veri görünümü</strong>
            <span>Bu değerler arayüz denetimi içindir; canlı Tayan kayıtları değildir.</span>
          </div>
        ) : null}
        {children}
      </section>
    </div>
  );
}
